module.exports = __webpack_public_path__ + "static/media/wine-glass-alt.138ac28a.svg";